import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import authProvider from '@utils/auth/createAuthProvider';

const { useAuth } = authProvider;

function withNotAuth(Component) {

  // eslint-disable-next-line
  return (props) => {

    const history = useHistory();
    const [logged] = useAuth();

    useEffect(
      () => {

        if (logged) history.push('/');

      },

      [logged, history],
    );

    // eslint-disable-next-line react/jsx-filename-extension
    return <Component {...props} />;

  };

}

export default withNotAuth;
